/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { BannerItem, GameItem, SubmitException, BadgeSummary, UploadInfo, WxTransferAuthState, WxTransferAuthPayload } from './types/common';

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return http.post('uploads', formData, {}, { 'content-type': 'multipart/form-data' });
};

export const uploadBlob = (blob, name = 'blob') => {
  const formData = new FormData();
  formData.append('name', name);
  formData.append('file', blob, name);
  return http.post('uploads', formData, {}, { 'content-type': 'multipart/form-data' });
};

export const uploadCosImgInfo = (imgInfo) => {
  const url = imgInfo.url;
  const formHead = { 'content-type': 'multipart/form-data' };
  imgInfo.headers.forEach((header) => {
    formHead[header.name] = header.value;
  });
  JSON.stringify(formHead);
  return http.put(url, imgInfo.file, {}, formHead);
};

export const uploadInfo = (size, extension) => http.get<UploadInfo>('upload-info', { size, extension });

export interface StartData {
  /** API版本号，与本地记录不一致时应清除缓存信息 */
  apiVersion: string;
  /** 是否启用发帖要求绑手机 */
  enablePostPhone: boolean;
  /** 主标题 */
  title: string;
  /** 首页帖子过滤器 */
  filter: string;
  /** 顶部轮播信息 */
  banners: BannerItem[];
  /** 广告信息（仅向APP提供） */
  ads: BannerItem[];
  /** 签到提示语 */
  signTips: string;
  /** 圈子信息 */
  game: GameItem;
  /** 是否支持切换圈子 */
  canSwitchGame: boolean;
}

export const getStart = () => http.get<StartData>('start');
export const getCities = () => http.get('cities');
export const getBadges = type => http.get<BadgeSummary>(`user/badges/${type}`, {}, { silent: true });
export const getQrcodes = body => http.post('qrcodes', body);
export const getInviteInfo = game => http.get('shares/invite', { game });
export const connect = body => http.post('connect', body);
export const getWechatSDKInfo = (url, apis = '') => http.post('jssdk/config', { url, apis }, { silent: true });
export const getWxTransferAuth = (errcodeExpected?) => http.get<WxTransferAuthState>('wxpay/transfer-auth', {}, { errcodeExpected });
export const postWxTransferAuth = () => http.post<WxTransferAuthPayload>('wxpay/transfer-auth');
export const getBankInfo = (card, silent) => http.get('bank-info', { card }, { silent });
export const getSubmitException = () => http.get<SubmitException[]>('submit-exception', { op: 'read' });
